import { Component, model, output } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "../../../shared.module";

@Component({
  selector: "vl-input-search-dialog",
  standalone: true,
  imports: [MatIcon, FormsModule, SharedModule],
  templateUrl: "./input-search-dialog.component.html",
  styleUrl: "./input-search-dialog.component.scss",
})
export class InputSearchDialogComponent {
  search = model<string>("");
  onClickSearch = output();
  close = output();

  onClick() {
    this.onClickSearch.emit();
  }

  onClose() {
    this.close.emit();
  }
}
